const lang1 = document.querySelectorAll(".plug__text-lang-1");
const lang2 = document.querySelectorAll(".plug__text-lang-2");

const toggleClass = (value) => {
  lang1.forEach(item => {
    item.classList.toggle(value);
  });
  lang2.forEach(item => {
    item.classList.toggle(value);
  });
};

const changeLang = () => {
  toggleClass("active");
  setTimeout(() => {
    toggleClass("hidden");
  }, 1000);
  setTimeout(changeLang, 7000);
};

const setFullHeight = () => {
  const windowHeight = document.documentElement.clientHeight > 550 ? `${document.documentElement.clientHeight}px` : "auto";
  document.body.style.height = windowHeight;
  document.body.style.minHeight = windowHeight;
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    changeLang();
  }, 6000);
  setFullHeight();
  window.addEventListener("resize", () => {
    setFullHeight();
  });
  window.onorientationchange = (event) => {
    if (event.target.screen.orientation.angle === 0) {
      setTimeout(() => {
        document.body.style.height = "100vh";
      }, 100);
    }
  };
});
